export const containerClassName = `flex items-center cursor-pointer px-[10px] py-[9px] rounded-[8px] mb-[2px] mx-[6px]`

export const nameClassName = 'text-sm-medium truncate flex-1'
